import React, { useEffect, useState, useRef } from "react";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useNavigate } from "react-router-dom";
// import courseVideo from "../../../assets/videos/demoVideo.mp4";
import userImg from "../../../assets/images/user.png";
import { Link } from "react-router-dom";
// import StudentCourseContent from "../../../components/StudentCourseContent/StudentCourseContent";
import { adminEnrolledCourseUnitApi } from "../../../redux/features/courseSlice";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Avatar from "../../../assets/images/Profile-thumbnail-small.svg";
import { Image } from "react-bootstrap";
import { addCommentToCurriculumApi } from "../../../redux/features/courseSlice";
import { voteCommentApi } from "../../../redux/features/courseSlice";
import { commentFlagApi } from "../../../redux/features/courseSlice";
import { getAllCommentsApi } from "../../../redux/features/courseSlice";
import toast from "react-hot-toast";
import {
  studentArticleReadApi,
  studentVideoWatchedApi,
} from "../../../redux/features/studentDetailSlice";
import { commentRemoveApi } from "../../../redux/features/courseSlice";
import { commentReplyApi } from "../../../redux/features/courseSlice";
import CourseCompleteSuccessModal from "../../../components/CourseCompleteSuccessModal/CourseCompleteSuccessModal";
import Notification from "../../../components/Notification/Notification";
import StudentCourseContentView from "../../../components/StudentCourseContentView/StudentCourseContentView";

const CourseContentData = [
  {
    id: 1,
    title: "Introduction",
    icon: "bi bi-file-earmark-play",
    duration: "4 min",
    type: "video",
    status: "Completed",
    className: "completed",
    isCompleted: true,
  },
  {
    id: 2,
    title: "Full Course Resources",
    icon: "bi bi-file-earmark-text",
    duration: "4 min",
    type: "article",
    status: "Inprogress",
    className: "inprogress",
    isCompleted: false,
  },
  {
    id: 3,
    title: "What is Figma?",
    icon: "bi bi-file-earmark-play",
    duration: "2 min",
    type: "video",
    status: "Not Complete",
    className: "",
    isCompleted: false,
  },
  {
    id: 4,
    title: "Setting Up Your Workspace",
    icon: "bi bi-file-earmark-check",
    duration: "3 min",
    type: "assignment",
    status: "Not Complete",
    className: "",
    isCompleted: false,
  },
  {
    id: 5,
    title: "Basic Tools Overview",
    icon: "bi bi-file-earmark-play",
    duration: "4 min",
    type: "video",
    status: "Not Complete",
    className: "",
    isCompleted: false,
  },
  {
    id: 6,
    title: "Creating Your First Frame",
    icon: "bi bi-file-earmark-check",
    duration: "5 min",
    type: "assignment",
    status: "Not Complete",
    className: "",
    isCompleted: false,
  },
  // {
  //   id: 7,
  //   title: "Using Shapes and Text",
  //   icon: "bi bi-file-earmark-text",
  //   duration: "4 min",
  //   type: "article",
  //   status: "Not Complete",
  //   className: "",
  //   isCompleted: false,
  // },
  // {
  //   id: 8,
  //   title: "Working with Layers",
  //   icon: "bi bi-file-earmark-check",
  //   duration: "3 min",
  //   type: "assignment",
  //   status: "Not Complete",
  //   className: "",
  //   isCompleted: false,
  // },
  // {
  //   id: 9,
  //   title: "Introduction to Components",
  //   icon: "bi bi-file-earmark-play",
  //   duration: "6 min",
  //   type: "video",
  //   status: "Not Complete",
  //   className: "",
  //   isCompleted: false,
  // },
  // {
  //   id: 10,
  //   title: "Prototyping Basics",
  //   icon: "bi bi-file-earmark-text",
  //   duration: "5 min",
  //   type: "article",
  //   status: "Not Complete",
  //   className: "",
  //   isCompleted: false,
  // },
  // {
  //   id: 11,
  //   title: "Advanced Prototyping Techniques",
  //   icon: "bi bi-file-earmark-check",
  //   duration: "7 min",
  //   type: "assignment",
  //   status: "Not Complete",
  //   className: "",
  //   isCompleted: false,
  // },
];
const mainComment = {
  username: "RALPH EDWARDS",
  text: `This is the main comment. In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque. 
    Fringilla pharetra vel massa enim sollicitudin cras.`,
  votes: 1,
  sendTime: "Aug 19, 2021",
};

const replies = [
  {
    username: "RALPH EDWARDS",
    text: `Reply 1: At pulvinar eget sociis adipiscing eget donec ultricies nibh tristique.`,
    votes: 1,
    sendTime: "Aug 19, 2021",
  },
  {
    username: "RALPH EDWARDS",
    text: `Reply 2: In mauris porttitor tincidunt mauris massa sit lorem sed scelerisque.`,
    votes: 1,
    sendTime: "Aug 19, 2021",
  },
  {
    username: "RALPH EDWARDS",
    text: `Reply 3: Fringilla pharetra vel massa enim sollicitudin cras.`,
    votes: 1,
    sendTime: "Aug 19, 2021",
  },
];
const StudentCourseViewDetail = ({
  onPrevious,
  onNext,
  hasPrevious,
  hasNext,
}) => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [courseUnit, setCourseUnit] = useState();
  const [activeUnitData, setActiveUnitData] = useState();
  const [commentList, setCommentList] = useState([]);
  const [commentLimit, setCommentLimit] = useState(3);
  const [readLessComment, setReadLessComment] = useState(false);
  const [courseCompletededModelShow, setCourseCompletededModelShow] =
    useState(false);
  const [comment, setComment] = useState("");
  const [subComment, setsubComment] = useState("");
  const [successText, setSuccessText] = useState("");
  const videoRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [commentReply, setCommentReply] = useState({
    id: null,
    show: false,
  });

  const navgate = useNavigate();
  const goBack = () => {
    navgate(-1);
  };
  const courseFetchCall = async () => {
    setIsLoading(true);
    try {
      const res = await dispatch(
        adminEnrolledCourseUnitApi({
          token: auth.token,
          courseId: searchParams.get("id"),
          unitId: searchParams.get("unit"),
        }),
      ).unwrap();
      if (res.success) {
        setCourseUnit(res?.data?.units);
        setSuccessText(res?.data?.course?.congratulation_message);
        if (
          res?.data?.unit?.currentlyActiveContent === null &&
          localStorage.getItem(`course${searchParams.get("id")}`) === null
        ) {
          setCourseCompletededModelShow(true);
        }
      } else {
        console.warn("API call failed:", res);
      }
    } catch (error) {
      console.error("Error fetching course data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    courseFetchCall();
  }, []);

  useEffect(() => {
    if (searchParams.get("unit")) {
      const curriculumId = searchParams.get("unit");

      if (courseUnit) {
        let filteredCourse = courseUnit.filter(
          (item) => item.id == curriculumId,
        );
        console.log(filteredCourse[0]?.curricula);
        filteredCourse[0]?.curricula?.map((item, index) => {
          if (index == 0 && item?.articles?.length > 0) {
            console.log(item);
            setActiveUnitData(item);
          }
          if (index == 0 && item?.videos?.length > 0) {
            console.log(item);
            setActiveUnitData(item);
          }
          if (index == 0 && item?.assignments?.length > 0) {
            console.log(item);
            setActiveUnitData(item);
          }
        });
      }
    }
  }, [courseUnit]);

  useEffect(() => {
    setCommentList(activeUnitData?.videos[0]?.comments);
  }, [activeUnitData?.videos]);

  const getAllComment = async (id) => {
    // await new Promise((resolve) => setTimeout(resolve, 5000));
    const res = await dispatch(
      getAllCommentsApi({
        token: auth.token,
        content: comment,
        videoId: id,
      }),
    ).unwrap();
    if (res.success) {
      console.log(res?.data?.comments);
      setCommentList(res?.data?.comments);
    }
  };
  const commentSend = async (id) => {
    const res = await dispatch(
      addCommentToCurriculumApi({
        token: auth.token,
        content: comment,
        videoId: id,
      }),
    ).unwrap();
    if (res.success) {
      toast.success(res?.message, {
        position: "top-center",
      });
      setComment("");
      getAllComment(id);
    }
  };
  const commebtRemoveHandler = async (comment) => {
    const res = await dispatch(
      commentRemoveApi({
        token: auth.token,
        commentId: comment?.id,
      }),
    ).unwrap();
    if (res.success) {
      toast.success(res?.message, {
        position: "top-center",
      });
      getAllComment(activeUnitData?.videos[0].id);
    }
  };

  const commentReplyHandler = async (id, comment) => {
    const res = await dispatch(
      commentReplyApi({
        token: auth.token,
        commentId: id?.id,
        comment: id?.comment,
      }),
    ).unwrap();
    if (res.success) {
      toast.success(res?.message, {
        position: "top-center",
      });
      setsubComment("");
      setCommentReply({
        id: null,
        show: false,
      });
      getAllComment(activeUnitData?.videos[0].id);
    }
  };

  const upVoteHandler = async (comment) => {
    const res = await dispatch(
      voteCommentApi({
        token: auth.token,
        voteType: "upvote",
        commentId: comment?.id,
      }),
    ).unwrap();
    if (res.success) {
      getAllComment(activeUnitData?.videos[0].id);
    }
  };

  const downVoteHandler = async (comment) => {
    const res = await dispatch(
      voteCommentApi({
        token: auth.token,
        voteType: "downvote",
        commentId: comment?.id,
      }),
    ).unwrap();
    if (res.success) {
      getAllComment(activeUnitData?.videos[0].id);
    }
  };

  const flagHandler = async (comment) => {
    const res = await dispatch(
      voteCommentApi({
        token: auth.token,
        voteType: "flag",
        commentId: comment?.id,
      }),
    ).unwrap();
    if (res.success) {
      getAllComment(activeUnitData?.videos[0].id);
    }
  };

  const videoWatchHandler = async (videoCurriculum) => {
    const res = await dispatch(
      studentVideoWatchedApi({
        token: auth.token,
        videoId: videoCurriculum?.videos[0]?.id,
      }),
    ).unwrap();
    if (res.success) {
      toast.success(res?.message, {
        position: "top-center",
      });
      courseFetchCall();
    }
  };

  return (
    <>
      {isLoading && (
        <div className="loader-container">
          <div className="dottedLoading theme-color"></div>
        </div>
      )}
      {/* Topbar */}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3
            className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
            onClick={goBack}
          >
            <span className="icon-arrow-left"></span>Course Videos: Introduction
            to the Course
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <Notification />
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-17">
        <h2 className="ah-heading-04 black-800 fw-bold">
          {activeUnitData?.content_type === "video"
            ? activeUnitData?.videos[0].title
            : activeUnitData?.content_type === "assignment"
              ? activeUnitData?.assignments[0].title
              : ""}
        </h2>
      </div>
      <div className="main-content d-inline-flex justify-content-between w-100">
        <div className="left-panel">
          {activeUnitData?.content_type === "video" ? (
            <div>
              <div className="card-default-style px-10 px-sm-20 px-md-30 py-10 py-sm-15 mb-16">
                <video
                  width="100%"
                  controls
                  className="course-video mb-13"
                  ref={videoRef}
                  //   onEnded={handleVideoEnd}
                >
                  <source
                    src={
                      process.env.REACT_APP_GALLERY_URL +
                      activeUnitData?.videos[0].video_url
                    }
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
                <span className="ah-text-xs fw-semibold theme-color">
                  <svg
                    className="me-5"
                    width="9"
                    height="10"
                    viewBox="0 0 9 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.73494 5.2496V8.60417C1.73494 8.73963 1.68957 8.85337 1.5982 8.94538C1.55404 8.99047 1.50107 9.02599 1.44259 9.04974C1.38411 9.07348 1.32137 9.08494 1.25827 9.08339C1.19492 9.08467 1.13197 9.0731 1.07322 9.04938C1.01446 9.02566 0.961127 8.99028 0.916424 8.94538C0.870826 8.90123 0.834854 8.84813 0.810772 8.78941C0.78669 8.73069 0.775018 8.66762 0.776491 8.60417V0.617109C0.776491 0.481648 0.822497 0.367913 0.914508 0.275902C0.958956 0.230834 1.01216 0.195341 1.07084 0.171605C1.12952 0.147869 1.19243 0.136394 1.25571 0.137885H4.87289C4.99046 0.137885 5.0927 0.17175 5.17832 0.238842C5.26458 0.306572 5.31889 0.392193 5.34253 0.497622L5.56873 1.41581H7.96485C8.10094 1.41581 8.21404 1.46182 8.30605 1.55383C8.35112 1.59828 8.38661 1.65148 8.41035 1.71016C8.43408 1.76884 8.44556 1.83176 8.44407 1.89504V6.04831C8.44407 6.18441 8.39806 6.29751 8.30605 6.38952C8.2616 6.43459 8.2084 6.47008 8.14972 6.49381C8.09104 6.51755 8.02813 6.52903 7.96485 6.52753H5.62176C5.51375 6.52857 5.40856 6.49298 5.32337 6.42658C5.23829 6.36323 5.17886 6.27137 5.15596 6.1678L4.92976 5.2496H1.73494ZM5.99492 5.56909H7.48562V2.37426H5.19621C5.08943 2.37512 4.98544 2.34015 4.90088 2.27493C4.81632 2.20971 4.75607 2.11802 4.72977 2.01452L4.50421 1.09633H1.73494V4.29116H5.30228C5.40906 4.2903 5.51305 4.32527 5.59761 4.39049C5.68217 4.45571 5.74242 4.5474 5.76872 4.65089L5.99492 5.56909Z"
                      fill="#F05203"
                    />
                  </svg>
                  Report an issue
                </span>
              </div>
              <div className="">
                <p className="mt-0 mb-17 pb-5 ah-text-sm theme-color fw-bold border-bottom border-black border-opacity-10 border-2">
                  Comments
                </p>
                <div className="comment-section">
                  <div className="d-flex align-items-center mb-24">
                    <Image
                      src={process.env.REACT_APP_GALLERY_URL + auth?.profilePic}
                      alt={"Avatar"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = Avatar;
                      }}
                      className="me-10 avatar-img"
                    />
                    <div
                      className="comment-input d-flex align-items-center card-green py-5 px-15"
                      data-card="tabs"
                    >
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Add a comment"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          commentSend(activeUnitData?.videos[0].id);
                        }}
                        className="btn btn-primary no-shadow ms-2 py-10"
                      >
                        POST
                      </button>
                    </div>
                  </div>
                  {/* Main Comment */}
                  {commentList &&
                    commentList.length > 0 &&
                    commentList.slice(0, commentLimit).map((item) => (
                      <>
                        <div className="comment-card mb-24">
                          <div className="d-flex">
                            <Image
                              src={
                                process.env.REACT_APP_GALLERY_URL +
                                item?.User?.profile_picture
                              }
                              alt={"Avatar"}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = Avatar;
                              }}
                            />
                            <div className="flex-grow-1 comment-content ms-20">
                              <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <p className="username mb-16 ah-text-base fw-bold">
                                  {item?.User?.full_name}
                                </p>
                                <p className="ah-text-sm text-gray-01">
                                  {new Date(item.created_at).toDateString()}
                                </p>
                              </div>
                              <p>{item?.content}</p>
                              <div className="actions d-flex align-items-center justify-content-end">
                                <span className="me-10">
                                  ({item?.upvotes} vote)
                                </span>
                                <span
                                  className={`me-10 cursor-pointer ${
                                    item?.upvoted && "theme-color"
                                  }`}
                                  onClick={() => {
                                    upVoteHandler(item);
                                  }}
                                >
                                  <svg
                                    className="me-5"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <mask
                                      id="mask0_2633_5533"
                                      style={{
                                        maskType: "alpha",
                                      }}
                                      maskUnits="userSpaceOnUse"
                                      x="0"
                                      y="0"
                                      width="16"
                                      height="16"
                                    >
                                      <g clipPath="url(#clip0_2633_5533)">
                                        <path
                                          d="M15.0171 11.6312L9.55145 2.13932C9.39314 1.86858 9.1667 1.644 8.89466 1.48794C8.62261 1.33187 8.31445 1.24976 8.00082 1.24976C7.68719 1.24976 7.37903 1.33187 7.10699 1.48794C6.83494 1.644 6.60851 1.86858 6.4502 2.13932L0.984571 11.6312C0.830958 11.8939 0.75 12.1928 0.75 12.4971C0.75 12.8015 0.830958 13.1003 0.984571 13.3631C1.14113 13.6352 1.36725 13.8607 1.63975 14.0166C1.91224 14.1724 2.22129 14.253 2.5352 14.2499H13.4664C13.7801 14.2527 14.0889 14.1721 14.3612 14.0162C14.6334 13.8604 14.8594 13.635 15.0158 13.3631C15.1696 13.1005 15.2508 12.8016 15.251 12.4973C15.2512 12.193 15.1705 11.894 15.0171 11.6312ZM13.7171 12.6124C13.6917 12.6558 13.655 12.6914 13.611 12.7156C13.567 12.7398 13.5173 12.7517 13.4671 12.7499H2.5352C2.485 12.7517 2.43528 12.7398 2.39127 12.7156C2.34726 12.6914 2.31062 12.6558 2.2852 12.6124C2.26364 12.5774 2.25222 12.537 2.25222 12.4959C2.25222 12.4547 2.26364 12.4144 2.2852 12.3793L7.75082 2.88745C7.77768 2.84551 7.81465 2.81101 7.85834 2.78711C7.90203 2.76321 7.95102 2.75068 8.00082 2.75068C8.05062 2.75068 8.09962 2.76321 8.1433 2.78711C8.18699 2.81101 8.22396 2.84551 8.25082 2.88745L13.7164 12.3793C13.7381 12.4143 13.7496 12.4546 13.7497 12.4958C13.7498 12.537 13.7385 12.5773 13.7171 12.6124Z"
                                          fill="black"
                                        />
                                      </g>
                                    </mask>
                                    <g mask="url(#mask0_2633_5533)">
                                      <rect
                                        width="16"
                                        height="16"
                                        fill={`${
                                          !item?.upvoted ? "#21242C" : "#F05203"
                                        }`}
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_2633_5533">
                                        <rect
                                          width="16"
                                          height="16"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  Upvote
                                </span>
                                <span
                                  className={`me-10 cursor-pointer ${
                                    item?.downvoted && "theme-color"
                                  }`}
                                  onClick={() => downVoteHandler(item)}
                                >
                                  <svg
                                    className="me-5"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <mask
                                      id="mask0_2633_5541"
                                      style={{
                                        maskType: "alpha",
                                      }}
                                      maskUnits="userSpaceOnUse"
                                      x="0"
                                      y="0"
                                      width="16"
                                      height="16"
                                    >
                                      <g clipPath="url(#clip0_2633_5541)">
                                        <path
                                          d="M0.982929 4.3688L6.44855 13.8607C6.60686 14.1314 6.8333 14.356 7.10534 14.5121C7.37739 14.6681 7.68555 14.7502 7.99918 14.7502C8.31281 14.7502 8.62097 14.6681 8.89301 14.5121C9.16506 14.356 9.39149 14.1314 9.5498 13.8607L15.0154 4.3688C15.169 4.10607 15.25 3.80721 15.25 3.50287C15.25 3.19852 15.169 2.89966 15.0154 2.63693C14.8589 2.36484 14.6327 2.13929 14.3603 1.98344C14.0878 1.82759 13.7787 1.74704 13.4648 1.75005H2.53355C2.21986 1.74726 1.91107 1.82792 1.63881 1.98376C1.36656 2.1396 1.14063 2.36502 0.984179 2.63693C0.830377 2.89955 0.749203 3.19835 0.748983 3.5027C0.748764 3.80704 0.829506 4.10596 0.982929 4.3688ZM2.28293 3.38755C2.30835 3.34424 2.345 3.3086 2.389 3.28439C2.43301 3.26019 2.48274 3.24833 2.53293 3.25005H13.4648C13.515 3.24833 13.5647 3.26019 13.6087 3.28439C13.6527 3.3086 13.6894 3.34424 13.7148 3.38755C13.7364 3.42261 13.7478 3.46296 13.7478 3.50412C13.7478 3.54527 13.7364 3.58562 13.7148 3.62068L8.24918 13.1126C8.22232 13.1545 8.18535 13.189 8.14166 13.2129C8.09797 13.2368 8.04898 13.2493 7.99918 13.2493C7.94938 13.2493 7.90038 13.2368 7.8567 13.2129C7.81301 13.189 7.77604 13.1545 7.74918 13.1126L2.28355 3.62068C2.2619 3.58568 2.25038 3.54536 2.25027 3.5042C2.25015 3.46305 2.26146 3.42267 2.28293 3.38755Z"
                                          fill="black"
                                        />
                                      </g>
                                    </mask>
                                    <g mask="url(#mask0_2633_5541)">
                                      <rect
                                        x="16"
                                        y="16"
                                        width="16"
                                        height="16"
                                        transform="rotate(180 16 16)"
                                        fill={`${
                                          !item?.downvoted
                                            ? "#21242C"
                                            : "#F05203"
                                        }`}
                                        fillOpacity="0.64"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_2633_5541">
                                        <rect
                                          width="16"
                                          height="16"
                                          fill="white"
                                          transform="matrix(-1 0 0 -1 16 16)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  Downvote
                                </span>
                                <span
                                  className={`me-10 cursor-pointer ${
                                    item.flagged && "theme-color"
                                  }`}
                                  onClick={() => flagHandler(item)}
                                >
                                  <svg
                                    className="me-5"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <mask
                                      id="mask0_2633_5549"
                                      style={{
                                        maskType: "alpha",
                                      }}
                                      maskUnits="userSpaceOnUse"
                                      x="0"
                                      y="0"
                                      width="16"
                                      height="16"
                                    >
                                      <g clipPath="url(#clip0_2633_5549)">
                                        <path
                                          d="M2.50876 2.93005C2.42712 3.00081 2.36173 3.08838 2.31707 3.18676C2.27241 3.28514 2.24954 3.39201 2.25001 3.50005V14C2.25001 14.199 2.32902 14.3897 2.46968 14.5304C2.61033 14.671 2.80109 14.75 3.00001 14.75C3.19892 14.75 3.38969 14.671 3.53034 14.5304C3.67099 14.3897 3.75001 14.199 3.75001 14V11.3575C5.17751 10.2875 6.38126 10.7875 8.16751 11.67C9.18188 12.17 10.3388 12.745 11.5925 12.745C12.5125 12.745 13.485 12.4363 14.4913 11.565C14.5723 11.4948 14.6373 11.4081 14.6819 11.3106C14.7265 11.2131 14.7498 11.1072 14.75 11V3.50005C14.75 3.35625 14.7087 3.21547 14.631 3.09448C14.5533 2.9735 14.4424 2.87741 14.3116 2.81767C14.1808 2.75793 14.0355 2.73706 13.8932 2.75754C13.7509 2.77802 13.6174 2.83898 13.5088 2.93317C11.9644 4.2713 10.7256 3.76505 8.83251 2.82817C7.07438 1.95442 4.88563 0.871298 2.50876 2.93005ZM13.25 10.6413C11.8225 11.7119 10.6188 11.2107 8.83251 10.3288C7.38501 9.61005 5.64563 8.75005 3.75001 9.61692V3.85567C5.17751 2.78567 6.38126 3.28567 8.16751 4.16817C9.18188 4.66817 10.3388 5.24317 11.5925 5.24317C12.1648 5.24403 12.7305 5.12011 13.25 4.88005V10.6413Z"
                                          fill="black"
                                        />
                                      </g>
                                    </mask>
                                    <g mask="url(#mask0_2633_5549)">
                                      <rect
                                        width="16"
                                        height="16"
                                        fill={`${
                                          !item?.flagged ? "#21242C" : "#F05203"
                                        }`}
                                        fillOpacity="0.64"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_2633_5549">
                                        <rect
                                          width="16"
                                          height="16"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  Flag
                                </span>
                                {auth.user_id == item?.User?.id &&
                                  auth.role !== "Admin" && (
                                    <span
                                      className={`me-10 cursor-pointer`}
                                      onClick={() => commebtRemoveHandler(item)}
                                    >
                                      <svg
                                        className="me-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      >
                                        <polyline points="3 6 5 6 21 6" />
                                        <path d="M19 6L18 20H6L5 6" />
                                        <path d="M10 11V17" />
                                        <path d="M14 11V17" />
                                        <path d="M9 6V4C9 3.4 9.4 3 10 3H14C14.6 3 15 3.4 15 4V6" />
                                      </svg>
                                      Remove
                                    </span>
                                  )}
                                {auth.role === "Admin" && (
                                  <span
                                    className={`me-10 cursor-pointer`}
                                    onClick={() => commebtRemoveHandler(item)}
                                  >
                                    <svg
                                      className="me-5"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    >
                                      <polyline points="3 6 5 6 21 6" />
                                      <path d="M19 6L18 20H6L5 6" />
                                      <path d="M10 11V17" />
                                      <path d="M14 11V17" />
                                      <path d="M9 6V4C9 3.4 9.4 3 10 3H14C14.6 3 15 3.4 15 4V6" />
                                    </svg>
                                    Remove
                                  </span>
                                )}
                                <span
                                  className={`me-10 cursor-pointer`}
                                  onClick={() =>
                                    setCommentReply({
                                      id: item.id,
                                      show: true,
                                    })
                                  }
                                >
                                  <svg
                                    className="me-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  >
                                    <path d="M10 9V5l-7 7 7 7v-4c4.55 0 7.42 1.92 9 6-1-5-4-10-9-10z" />
                                  </svg>
                                  Reply
                                </span>
                              </div>
                              {commentReply.show &&
                                item.id === commentReply.id && (
                                  <div className="d-flex gap-3 align-items-center">
                                    <div className="comment-input d-flex align-items-center card-green py-5 px-15 mt-15">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Add a comment"
                                        value={subComment}
                                        onChange={(e) =>
                                          setsubComment(e.target.value)
                                        }
                                      />
                                      <button
                                        type="button"
                                        onClick={() =>
                                          commentReplyHandler({
                                            id: item.id,
                                            comment: subComment,
                                          })
                                        }
                                        className="btn btn-primary no-shadow ms-2 py-10"
                                      >
                                        POST
                                      </button>
                                    </div>
                                    <svg
                                      className="cursor-pointer"
                                      onClick={() =>
                                        setCommentReply({ id: 0, show: false })
                                      }
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    >
                                      <line x1="18" y1="6" x2="6" y2="18" />
                                      <line x1="6" y1="6" x2="18" y2="18" />
                                    </svg>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                        {item?.replies?.length > 0 &&
                          item?.replies.map((item2) => (
                            <div className="reply-card mb-24">
                              <div className="d-flex">
                                <Image
                                  src={
                                    process.env.REACT_APP_GALLERY_URL +
                                    item2?.User?.profile_picture
                                  }
                                  alt={"Avatar"}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = Avatar;
                                  }}
                                />
                                <div className="flex-grow-1 comment-content ms-20">
                                  <div className="d-flex justify-content-between align-items-center flex-wrap">
                                    <p className="username mb-16 ah-text-base fw-bold">
                                      {item2?.User?.full_name}
                                    </p>
                                    <p className="ah-text-sm text-gray-01">
                                      {new Date(
                                        item2.created_at,
                                      ).toDateString()}
                                    </p>
                                  </div>
                                  <p>{item2?.content}</p>
                                  <div className="actions d-flex align-items-center justify-content-end">
                                    <span className="me-10">
                                      ({item2?.upvotes} vote)
                                    </span>
                                    <span
                                      className={`me-10 cursor-pointer ${
                                        item2?.upvoted && "theme-color"
                                      }`}
                                      onClick={() => {
                                        upVoteHandler(item2);
                                      }}
                                    >
                                      <svg
                                        className="me-5"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <mask
                                          id="mask0_2633_5533"
                                          style={{
                                            maskType: "alpha",
                                          }}
                                          maskUnits="userSpaceOnUse"
                                          x="0"
                                          y="0"
                                          width="16"
                                          height="16"
                                        >
                                          <g clipPath="url(#clip0_2633_5533)">
                                            <path
                                              d="M15.0171 11.6312L9.55145 2.13932C9.39314 1.86858 9.1667 1.644 8.89466 1.48794C8.62261 1.33187 8.31445 1.24976 8.00082 1.24976C7.68719 1.24976 7.37903 1.33187 7.10699 1.48794C6.83494 1.644 6.60851 1.86858 6.4502 2.13932L0.984571 11.6312C0.830958 11.8939 0.75 12.1928 0.75 12.4971C0.75 12.8015 0.830958 13.1003 0.984571 13.3631C1.14113 13.6352 1.36725 13.8607 1.63975 14.0166C1.91224 14.1724 2.22129 14.253 2.5352 14.2499H13.4664C13.7801 14.2527 14.0889 14.1721 14.3612 14.0162C14.6334 13.8604 14.8594 13.635 15.0158 13.3631C15.1696 13.1005 15.2508 12.8016 15.251 12.4973C15.2512 12.193 15.1705 11.894 15.0171 11.6312ZM13.7171 12.6124C13.6917 12.6558 13.655 12.6914 13.611 12.7156C13.567 12.7398 13.5173 12.7517 13.4671 12.7499H2.5352C2.485 12.7517 2.43528 12.7398 2.39127 12.7156C2.34726 12.6914 2.31062 12.6558 2.2852 12.6124C2.26364 12.5774 2.25222 12.537 2.25222 12.4959C2.25222 12.4547 2.26364 12.4144 2.2852 12.3793L7.75082 2.88745C7.77768 2.84551 7.81465 2.81101 7.85834 2.78711C7.90203 2.76321 7.95102 2.75068 8.00082 2.75068C8.05062 2.75068 8.09962 2.76321 8.1433 2.78711C8.18699 2.81101 8.22396 2.84551 8.25082 2.88745L13.7164 12.3793C13.7381 12.4143 13.7496 12.4546 13.7497 12.4958C13.7498 12.537 13.7385 12.5773 13.7171 12.6124Z"
                                              fill="black"
                                            />
                                          </g>
                                        </mask>
                                        <g mask="url(#mask0_2633_5533)">
                                          <rect
                                            width="16"
                                            height="16"
                                            fill={`${
                                              !item2?.upvoted
                                                ? "#21242C"
                                                : "#F05203"
                                            }`}
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_2633_5533">
                                            <rect
                                              width="16"
                                              height="16"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      Upvote
                                    </span>
                                    <span
                                      className={`me-10 cursor-pointer ${
                                        item2?.downvoted && "theme-color"
                                      }`}
                                      onClick={() => downVoteHandler(item2)}
                                    >
                                      <svg
                                        className="me-5"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <mask
                                          id="mask0_2633_5541"
                                          style={{
                                            maskType: "alpha",
                                          }}
                                          maskUnits="userSpaceOnUse"
                                          x="0"
                                          y="0"
                                          width="16"
                                          height="16"
                                        >
                                          <g clipPath="url(#clip0_2633_5541)">
                                            <path
                                              d="M0.982929 4.3688L6.44855 13.8607C6.60686 14.1314 6.8333 14.356 7.10534 14.5121C7.37739 14.6681 7.68555 14.7502 7.99918 14.7502C8.31281 14.7502 8.62097 14.6681 8.89301 14.5121C9.16506 14.356 9.39149 14.1314 9.5498 13.8607L15.0154 4.3688C15.169 4.10607 15.25 3.80721 15.25 3.50287C15.25 3.19852 15.169 2.89966 15.0154 2.63693C14.8589 2.36484 14.6327 2.13929 14.3603 1.98344C14.0878 1.82759 13.7787 1.74704 13.4648 1.75005H2.53355C2.21986 1.74726 1.91107 1.82792 1.63881 1.98376C1.36656 2.1396 1.14063 2.36502 0.984179 2.63693C0.830377 2.89955 0.749203 3.19835 0.748983 3.5027C0.748764 3.80704 0.829506 4.10596 0.982929 4.3688ZM2.28293 3.38755C2.30835 3.34424 2.345 3.3086 2.389 3.28439C2.43301 3.26019 2.48274 3.24833 2.53293 3.25005H13.4648C13.515 3.24833 13.5647 3.26019 13.6087 3.28439C13.6527 3.3086 13.6894 3.34424 13.7148 3.38755C13.7364 3.42261 13.7478 3.46296 13.7478 3.50412C13.7478 3.54527 13.7364 3.58562 13.7148 3.62068L8.24918 13.1126C8.22232 13.1545 8.18535 13.189 8.14166 13.2129C8.09797 13.2368 8.04898 13.2493 7.99918 13.2493C7.94938 13.2493 7.90038 13.2368 7.8567 13.2129C7.81301 13.189 7.77604 13.1545 7.74918 13.1126L2.28355 3.62068C2.2619 3.58568 2.25038 3.54536 2.25027 3.5042C2.25015 3.46305 2.26146 3.42267 2.28293 3.38755Z"
                                              fill="black"
                                            />
                                          </g>
                                        </mask>
                                        <g mask="url(#mask0_2633_5541)">
                                          <rect
                                            x="16"
                                            y="16"
                                            width="16"
                                            height="16"
                                            transform="rotate(180 16 16)"
                                            fill={`${
                                              !item2?.downvoted
                                                ? "#21242C"
                                                : "#F05203"
                                            }`}
                                            fillOpacity="0.64"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_2633_5541">
                                            <rect
                                              width="16"
                                              height="16"
                                              fill="white"
                                              transform="matrix(-1 0 0 -1 16 16)"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      Downvote
                                    </span>
                                    <span
                                      className={`me-10 cursor-pointer ${
                                        item2.flagged && "theme-color"
                                      }`}
                                      onClick={() => flagHandler(item2)}
                                    >
                                      <svg
                                        className="me-5"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <mask
                                          id="mask0_2633_5549"
                                          style={{
                                            maskType: "alpha",
                                          }}
                                          maskUnits="userSpaceOnUse"
                                          x="0"
                                          y="0"
                                          width="16"
                                          height="16"
                                        >
                                          <g clipPath="url(#clip0_2633_5549)">
                                            <path
                                              d="M2.50876 2.93005C2.42712 3.00081 2.36173 3.08838 2.31707 3.18676C2.27241 3.28514 2.24954 3.39201 2.25001 3.50005V14C2.25001 14.199 2.32902 14.3897 2.46968 14.5304C2.61033 14.671 2.80109 14.75 3.00001 14.75C3.19892 14.75 3.38969 14.671 3.53034 14.5304C3.67099 14.3897 3.75001 14.199 3.75001 14V11.3575C5.17751 10.2875 6.38126 10.7875 8.16751 11.67C9.18188 12.17 10.3388 12.745 11.5925 12.745C12.5125 12.745 13.485 12.4363 14.4913 11.565C14.5723 11.4948 14.6373 11.4081 14.6819 11.3106C14.7265 11.2131 14.7498 11.1072 14.75 11V3.50005C14.75 3.35625 14.7087 3.21547 14.631 3.09448C14.5533 2.9735 14.4424 2.87741 14.3116 2.81767C14.1808 2.75793 14.0355 2.73706 13.8932 2.75754C13.7509 2.77802 13.6174 2.83898 13.5088 2.93317C11.9644 4.2713 10.7256 3.76505 8.83251 2.82817C7.07438 1.95442 4.88563 0.871298 2.50876 2.93005ZM13.25 10.6413C11.8225 11.7119 10.6188 11.2107 8.83251 10.3288C7.38501 9.61005 5.64563 8.75005 3.75001 9.61692V3.85567C5.17751 2.78567 6.38126 3.28567 8.16751 4.16817C9.18188 4.66817 10.3388 5.24317 11.5925 5.24317C12.1648 5.24403 12.7305 5.12011 13.25 4.88005V10.6413Z"
                                              fill="black"
                                            />
                                          </g>
                                        </mask>
                                        <g mask="url(#mask0_2633_5549)">
                                          <rect
                                            width="16"
                                            height="16"
                                            fill={`${
                                              !item2?.flagged
                                                ? "#21242C"
                                                : "#F05203"
                                            }`}
                                            fillOpacity="0.64"
                                          />
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_2633_5549">
                                            <rect
                                              width="16"
                                              height="16"
                                              fill="white"
                                            />
                                          </clipPath>
                                        </defs>
                                      </svg>
                                      Flag
                                    </span>
                                    {auth.user_id === item2?.User?.id &&
                                      auth.role !== "Admin" && (
                                        <span
                                          className={`me-10 cursor-pointer`}
                                          onClick={() =>
                                            commebtRemoveHandler(item2)
                                          }
                                        >
                                          <svg
                                            className="me-5"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          >
                                            <polyline points="3 6 5 6 21 6" />
                                            <path d="M19 6L18 20H6L5 6" />
                                            <path d="M10 11V17" />
                                            <path d="M14 11V17" />
                                            <path d="M9 6V4C9 3.4 9.4 3 10 3H14C14.6 3 15 3.4 15 4V6" />
                                          </svg>
                                          Remove
                                        </span>
                                      )}
                                    {auth.role === "Admin" && (
                                      <span
                                        className={`me-10 cursor-pointer`}
                                        onClick={() =>
                                          commebtRemoveHandler(item)
                                        }
                                      >
                                        <svg
                                          className="me-5"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        >
                                          <polyline points="3 6 5 6 21 6" />
                                          <path d="M19 6L18 20H6L5 6" />
                                          <path d="M10 11V17" />
                                          <path d="M14 11V17" />
                                          <path d="M9 6V4C9 3.4 9.4 3 10 3H14C14.6 3 15 3.4 15 4V6" />
                                        </svg>
                                        Remove
                                      </span>
                                    )}
                                    {/* <span
                                      className={`me-10 cursor-pointer`}
                                      onClick={() =>
                                        setCommentReply({
                                          id: item2.id,
                                          show: true,
                                        })
                                      }
                                    >
                                      <svg
                                        className="me-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      >
                                        <path d="M10 9V5l-7 7 7 7v-4c4.55 0 7.42 1.92 9 6-1-5-4-10-9-10z" />
                                      </svg>
                                      Reply
                                    </span> */}
                                  </div>
                                  {commentReply.show &&
                                    item2.id === commentReply.id && (
                                      <div className="d-flex gap-3 align-items-center">
                                        <div className="comment-input d-flex align-items-center card-green py-5 px-15 mt-15">
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Add a comment"
                                            value={subComment}
                                            onChange={(e) =>
                                              setsubComment(e.target.value)
                                            }
                                          />
                                          <button
                                            type="button"
                                            onClick={() =>
                                              commentReplyHandler({
                                                id: item2.id,
                                                comment: subComment,
                                              })
                                            }
                                            className="btn btn-primary no-shadow ms-2 py-10"
                                          >
                                            POST
                                          </button>
                                        </div>
                                        <svg
                                          className="cursor-pointer"
                                          onClick={() =>
                                            setCommentReply({
                                              id: 0,
                                              show: false,
                                            })
                                          }
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          stroke-width="2"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        >
                                          <line x1="18" y1="6" x2="6" y2="18" />
                                          <line x1="6" y1="6" x2="18" y2="18" />
                                        </svg>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          ))}
                      </>
                    ))}
                  {commentList?.length > 3 && (
                    <>
                      {readLessComment ? (
                        <span
                          className="ah-text-sm fw-bolder cursor-pointer"
                          onClick={() => {
                            setReadLessComment(false);
                            setCommentLimit(3);
                          }}
                        >
                          Less Show
                        </span>
                      ) : (
                        <span
                          className="ah-text-sm fw-bolder cursor-pointer"
                          onClick={() => {
                            setCommentLimit(commentList?.length);
                            if (commentList?.length > 3) {
                              setReadLessComment(true);
                            } else {
                              setReadLessComment(false);
                            }
                          }}
                        >
                          See {commentList?.length} more answers
                        </span>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          ) : activeUnitData?.content_type === "article" ? (
            <div>
              <div className="card-default-style px-10 px-sm-20 px-md-30 py-10 py-sm-30 mb-16">
                {/* <div className="text-end mb-12">
                  <span
                    className="theme-color fw-semibold cursor-pointer"
                    onClick={() => markAsRead(activeUnitData)}
                  >
                    Mark As Read
                  </span>
                </div> */}
                <h2 className="ah-heading-04 black-800 fw-bold">
                  {activeUnitData.articles[0].title}
                </h2>
                <p className="mb-0">{activeUnitData.articles[0].content}</p>
              </div>
            </div>
          ) : activeUnitData?.content_type === "assignment" ? (
            <div>
              <div className="card-default-style py-10 py-sm-15 py-md-25 px-10 px-sm-20 px-md-30 px-lg-45">
                <h3 className="ah-heading-04 fw-bold black-100 mb-21">
                  Assignment
                </h3>
                <p>{activeUnitData?.assignments[0]?.description}</p>
                <div
                  className="card-green py-17 px-24 d-flex justify-content-between align-items-center flex-wrap gap-3 mb-27"
                  data-card="tabs"
                >
                  <div>
                    <h3 className="mb-20 ah-heading-05 fw-semibold text-black">
                      Grade Assignment
                    </h3>
                    <span className="ah-text-base me-16">
                      <strong>Questions</strong> :{" "}
                      {activeUnitData?.assignments[0]?.totalQuestions}
                    </span>
                    <span className="ah-text-base me-16">
                      <strong>Duration</strong> :{" "}
                      {activeUnitData?.assignments[0]?.duration} min
                    </span>
                    <span className="ah-text-base">
                      <strong>Type</strong> :{" "}
                      {activeUnitData?.assignments[0]?.type.includes(
                        "short_answer",
                      )
                        ? "Short Question"
                        : activeUnitData?.assignments[0]?.type.includes(
                              "multiple_choice",
                            )
                          ? "Multiple Choice"
                          : activeUnitData?.assignments[0]?.type.includes(
                                "comprehensive",
                              )
                            ? "Comprehensive"
                            : ""}
                    </span>
                  </div>
                  <Link
                    className="btn btn-primary no-shadow px-30"
                    to={`/view-assignment?id=${activeUnitData.Assignments[0]?.id}&view=true`}
                    type="button"
                  >
                    View Assignment
                  </Link>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="right-panel">
          <div className="card-default-style px-10 px-sm-15 px-md-21 pt-10 pt-sm-15 pt-md-32 pb-10 pb-sm-13 pb-md-17">
            <div className="course-videos-list">
              {courseUnit && (
                <StudentCourseContentView
                  CourseContentData={CourseContentData}
                  courseUnit={courseUnit.find(
                    (item) => item.id === Number(searchParams.get("unit")),
                  )}
                  setActiveUnitData={setActiveUnitData}
                  activeUnitData={activeUnitData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <CourseCompleteSuccessModal
        text={successText}
        show={courseCompletededModelShow}
        handleClose={() => setCourseCompletededModelShow(false)}
        handleContinue={() => {
          localStorage.setItem(`course${searchParams.get("id")}`, true);
          setCourseCompletededModelShow(false);
        }}
      />
    </>
  );
};

export default StudentCourseViewDetail;
